export enum EventTypeIdentifier {
  TEST = 'TEST',
  BUS_STOP = 'BUS_STOP',
  BUS_STOP_MATCH = 'BUS_STOP_MATCH',
  BUS_STOP_TEST = 'BUS_STOP_TEST',
  BUS_LANE_MATCH = 'BUS_LANE_MATCH',
  BUS_LANE_PARKING_MATCH = 'BUS_LANE_PARKING_MATCH',
  BUS_STOP_PARKING = 'BUS_STOP_PARKING',
  BUS_STOP_PARKING_MATCH = 'BUS_STOP_PARKING_MATCH',
  BUS_LANE_PARKING_TEST = 'BUS_LANE_PARKING_TEST',
  BUS_LANE_MOVING = 'BUS_LANE_MOVING',
  BUS_LANE_MOVING_MATCH = 'BUS_LANE_MOVING_MATCH',
  BUS_LANE_MOVING_TEST = 'BUS_LANE_MOVING_TEST',
  BUS_LANE_PARKING = 'BUS_LANE_PARKING',
  BUS_LANE = 'BUS_LANE',
  BIKE_LANE = 'BIKE_LANE',
  BIKE_LANE_TEST = 'BIKE_LANE_TEST',
  NO_STOPPING = 'NO_STOPPING',
  NO_STOPPING_TEST = 'NO_STOPPING_TEST',
  DOUBLE_YELLOW = 'DOUBLE_YELLOW',
  DOUBLE_PARKED = 'DOUBLE_PARKED',
  DOUBLE_PARKED_MATCH = 'DOUBLE_PARKED_MATCH',
  DOUBLE_PARKED_TEST = 'DOUBLE_PARKED_TEST',
  DOUBLE_PARKED_NO_STANDING = 'DOUBLE_PARKED_NO_STANDING',
  DOUBLE_PARKED_NON_COMMERCIAL_MATCH = 'DOUBLE_PARKED_NON_COMMERCIAL_MATCH',
  STREETCAR_STOP = 'STREETCAR_STOP',
  STREETCAR_BLOCKED = 'STREETCAR_BLOCKED',
  PERIODIC_SAMPLING = 'PERIODIC_SAMPLING',
  ROADWORKS = 'ROADWORKS',
  OUTSIDE_ROUTE = 'OUTSIDE_ROUTE',
  METER_PARKING = 'METER_PARKING',
  LOADING_ZONE = 'LOADING_ZONE',
}
